import React from 'react';
import UnderConstruction from '../../components/molecules/UnderConstruction.jsx';

function AzureReports() {
  return (
    <UnderConstruction title="Azure Reports" />
  );
}

export default AzureReports;


